const timesheetServiceServiceName = "/TimesheetManagement";

export async function timesheetManagementService(http) {
    return {        
        getPersonnelDailyWorkAsync: async (personnelCode, fromDate, toDate, year) => {
            return await http.post(timesheetServiceServiceName + "/GetPersonnelDailyWorkAsync", {
                PersonnelCode: personnelCode,
                FromDate: fromDate,
                ToDate: toDate,
                Year: year
            });
        }

    }
}













